import { createDeleteVehicleStore } from './createDeleteVehicleStore';
import { deleteVehicleLoader } from '../use-cases/deleteVehicleLoader';
import { createGetVehicleStores } from './createGetVehicleStores';
import { getVehiclesLoader } from '../use-cases/getVehiclesLoader';
import { createAddVehicleStore } from './createAddVehicleStore';
import { addVehicleLoader } from '../use-cases/addVehicleLoader';
import { Gateway } from '../../../../shared/api/gateway/Gateway';
import { createEditVehicleStore } from './createEditVehicleStore';
import { editVehicleLoader } from '../use-cases/editVehicleLoader';

export function createVehicleStores(myGateway: Gateway) {
	const getVehicleStore = createGetVehicleStores(getVehiclesLoader(myGateway));
	const addVehicleStore = createAddVehicleStore(addVehicleLoader(myGateway));
	const editVehicleStore = createEditVehicleStore(editVehicleLoader(myGateway));
	const deleteVehicleStore = createDeleteVehicleStore(
		deleteVehicleLoader(myGateway),
	);

	return {
		getVehicleStore,
		addVehicleStore,
		editVehicleStore,
		deleteVehicleStore,
	};
}
